(() => {
  function groupFor(title) {
    if (/beruf|bewach/i.test(title)) return 'Berufswaffenträger / Bewachungsgewerbe';
    if (/sport/i.test(title)) return 'Sportschütze';
    if (/vip/i.test(title)) return 'VIP / individuelle Abstimmung';
    return '';
  }
  function prefillContact() {
    const form = document.querySelector('#WskParticipantContact');
    if (!form || form.dataset.prefilled) return;
    form.dataset.prefilled = 'true';
    const params = new URLSearchParams(window.location.hash.slice(1));
    const contexts = JSON.parse(document.querySelector('#br-wsk-cart-context')?.textContent || '[]');
    const fill = context => {
      const course = form.querySelector('#wsk-course');
      const group = form.querySelector('#wsk-group');
      if (course && context.course) course.value = context.course.slice(0, 200);
      if (group) group.value = context.group || groupFor(context.variant || context.course || '');
    };
    const order = form.querySelector('#wsk-order');
    if (order && params.get('order')) order.value = params.get('order').slice(0, 40);
    if (params.get('course')) fill({course: params.get('course'), group: params.get('group')});
    else if (contexts.length === 1) fill(contexts[0]);
    const chooser = form.querySelector('#wsk-cart-course');
    if (chooser && contexts.length > 1 && !params.get('course')) {
      chooser.parentElement.hidden = false;
      contexts.forEach((context, index) => {
        const option = document.createElement('option');
        option.value = String(index); option.textContent = context.course; chooser.append(option);
      });
      chooser.addEventListener('change', () => { if (chooser.value !== '') fill(contexts[Number(chooser.value)]); });
    }
  }
  function sync(box) {
    const form = box.closest('form');
    const variant = form.querySelector('[name="id"]');
    const title = variant?.selectedOptions?.[0]?.textContent || '';
    const link = box.querySelector('[data-wsk-followup]');
    const variants = JSON.parse(box.querySelector('[data-wsk-context]')?.textContent || '{}');
    const context = variants[variant?.value];
    if (link && context) link.href = link.href.split('#')[0] + '#' + new URLSearchParams({course: context.course, group: box.dataset.vip === 'true' ? 'VIP / individuelle Abstimmung' : groupFor(context.variant)});
    const count = box.dataset.vip === 'true' ? Math.max(1, Math.min(5, parseInt(title.trim(), 10) || 1)) : 1;
    box.querySelector('[data-wsk-count]').value = count;
    box.querySelectorAll('[data-wsk-person]').forEach(fieldset => {
      const inactive = Number(fieldset.dataset.wskPerson) > count;
      fieldset.hidden = inactive;
      fieldset.disabled = inactive;
    });
    const quantity = form.querySelector('[name="quantity"]');
    if (quantity) { quantity.value = '1'; quantity.max = '1'; quantity.readOnly = true; }
  }
  function init() {
    prefillContact();
    document.querySelectorAll('[data-wsk-registration]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const form = box.closest('form');
      sync(box);
      form.addEventListener('change', () => setTimeout(() => sync(box), 0));
      form.addEventListener('submit', event => {
        sync(box);
        if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      form.querySelector('[name="add"]')?.addEventListener('click', event => {
        sync(box);
        if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
    });
  }
  document.addEventListener('click', event => {
    const cartRow = event.target.closest('tr');
    const cartQuantity = cartRow?.querySelector('[id^="Updates_"]');
    const cartRegistry = JSON.parse(document.querySelector('#br-wsk-variants')?.textContent || '{}');
    const cartVariant = cartQuantity?.getAttribute('id')?.split('_')[1]?.split(':')[0];
    const quantityButton = event.target.closest('button');
    if (cartRegistry[cartVariant] && quantityButton && /erhöhen|increase/i.test(quantityButton.getAttribute('aria-label') || quantityButton.textContent)) {
      event.preventDefault(); event.stopImmediatePropagation();
      window.location.assign(cartRegistry[cartVariant]); return;
    }
    const quick = event.target.closest('.js-btn-quickview, .js-grid-cart');
    const courses = JSON.parse(document.querySelector('#br-wsk-courses')?.textContent || '[]');
    if (quick) {
      const registry = JSON.parse(document.querySelector('#br-wsk-variants')?.textContent || '{}');
      const handle = quick.dataset.handle;
      const target = registry[quick.dataset.id] || (courses.includes(handle) ? '/products/' + handle : null);
      if (target) { event.preventDefault(); event.stopImmediatePropagation(); window.location.assign(target); return; }
    }
    const button = event.target.closest('.qv-add-button');
    if (!button) return;
    const link = document.querySelector('#jsQuickview .qv-view-product');
    const url = link?.getAttribute('href') || '';
    if (courses.some(handle => url.includes('/products/' + handle))) {
      event.preventDefault(); event.stopImmediatePropagation(); window.location.assign(url);
    }
  }, true);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('[id^="Updates_"]')) return;
    const registry = JSON.parse(document.querySelector('#br-wsk-variants')?.textContent || '{}');
    const variant = input.getAttribute('id').split('_')[1].split(':')[0];
    if (registry[variant] && Number(input.value) > 1) {
      input.value = '1'; event.stopImmediatePropagation(); window.location.assign(registry[variant]);
    }
  }, true);
  document.addEventListener('shopify:section:load', init);
  init();
})();
